import React from 'react';
import PropTypes from 'prop-types';
import InputIcon from './components/input-icon';
import ActionButton from '../../../action-button';
import Paragraph from '../../../paragraph';
import Box from '../../../box';

const DomainSelectorEmptyState = ({ title, actionButtonLabel, onClick }) => (
  <div className="ws-ui-domain-selector-empty-state">
    <Box
      paddingTop="spacing-3-xs"
      paddingLeft="spacing-xs"
      paddingRight="spacing-xs"
      paddingBottom="spacing-m"
      breakpoints={{
        md: {
          paddingTop: 'spacing-xs',
          paddingLeft: 'spacing-m',
          paddingRight: 'spacing-m',
          paddingBottom: 'spacing-l',
        },
      }}
    >
      <div className="ws-ui-domain-selector-empty-state__container">
        <Box paddingLeft="spacing-m" paddingRight="spacing-m">
          <InputIcon />
        </Box>
        <Paragraph size="large" align="center">
          {title}
        </Paragraph>
        <Box marginTop="spacing-xs">
          <ActionButton
            appearance="accent"
            format="solid"
            label={actionButtonLabel}
            onClick={onClick}
          />
        </Box>
      </div>
    </Box>
  </div>
);

DomainSelectorEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  actionButtonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DomainSelectorEmptyState;
